export { CloseOutlined } from '@ant-design/icons-vue'

export const CloseIconClass =
  'absolute top-[16px] right-[16px] text-14 text-font-40 hover:text-primary'

export const CloseIconOutClass =
  'absolute top-[0px] -right-[40px] text-12 text-white w-[28px] h-[28px] border-[1px] border-solid border-[var(--back-0-30)] bg-[var(--text-1-40)] flex-y-center justify-center rounded-full hover:bg-[var(--text-1-60)]'

export const CloseIconStandardClass =
  'cursor-pointer text-12 text-white w-[28px] h-[28px] border-[1px] border-solid border-[var(--back-0-30)] bg-[var(--text-1-40)] flex-y-center justify-center rounded-full hover:bg-[var(--text-1-60)]'
